import { ProductsMock } from "./mock";

export const getProducts = (path: string) => {
  const product =
    ProductsMock.find((value: any) => value.path === path) || null;
  return product;
};
